import { render, staticRenderFns } from "./VPhone.vue?vue&type=template&id=3af1c829"
import script from "./VPhone.vue?vue&type=script&lang=js"
export * from "./VPhone.vue?vue&type=script&lang=js"
import style0 from "./VPhone.vue?vue&type=style&index=0&id=3af1c829&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports